import React, { useState, useEffect } from 'react';
import './OnboardingTour.css';

const OnboardingTour = ({ isVisible, onComplete, steps = [] }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isActive, setIsActive] = useState(false);

  const defaultSteps = [
    {
      target: '.wallet-button',
      title: 'Connect Your Wallet',
      content: 'First, connect your Hedera wallet to access your NFT collection. We support HashPack, Blade, and other Hedera wallets.',
      position: 'bottom-left'
    },
    {
      target: '.gallery-selection',
      title: 'Choose Your Gallery',
      content: 'Select from our free gallery templates or explore premium NFT gallery spaces. Each offers a unique way to showcase your art.',
      position: 'top'
    },
    {
      target: '.scene-container',
      title: 'Explore in 3D',
      content: 'Use your mouse or touch controls to navigate around your gallery. Click on display spots to add your NFTs.',
      position: 'center'
    },
    {
      target: '.control-bar',
      title: 'Gallery Controls',
      content: 'Use these controls to take screenshots, share your gallery, and access additional settings.',
      position: 'top'
    }
  ];

  const tourSteps = steps.length > 0 ? steps : defaultSteps;

  useEffect(() => {
    if (isVisible) {
      setIsActive(true);
      setCurrentStep(0);
    } else {
      setIsActive(false);
    }
  }, [isVisible]);

  const nextStep = () => {
    if (currentStep < tourSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      completeTour();
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const completeTour = () => {
    setIsActive(false);
    if (onComplete) {
      onComplete();
    }
  };

  const skipTour = () => {
    completeTour();
  };

  if (!isActive || !tourSteps[currentStep]) {
    return null;
  }

  const step = tourSteps[currentStep];
  const progress = ((currentStep + 1) / tourSteps.length) * 100;

  return (
    <>
      {/* Overlay */}
      <div className="onboarding-overlay" />
      
      {/* Tour Step */}
      <div className={`onboarding-step ${step.position || 'center'}`}>
        <div className="onboarding-card">
          <div className="onboarding-header">
            <h3 className="onboarding-title">{step.title}</h3>
            <button 
              className="onboarding-close"
              onClick={skipTour}
              aria-label="Skip tour"
            >
              ×
            </button>
          </div>
          
          <div className="onboarding-content">
            <p>{step.content}</p>
          </div>
          
          <div className="onboarding-progress">
            <div 
              className="onboarding-progress-bar"
              style={{ width: `${progress}%` }}
            />
          </div>
          
          <div className="onboarding-footer">
            <div className="onboarding-step-counter">
              {currentStep + 1} of {tourSteps.length}
            </div>
            
            <div className="onboarding-actions">
              {currentStep > 0 && (
                <button 
                  className="onboarding-btn secondary"
                  onClick={prevStep}
                >
                  Previous
                </button>
              )}
              
              <button 
                className="onboarding-btn primary"
                onClick={nextStep}
              >
                {currentStep < tourSteps.length - 1 ? 'Next' : 'Get Started'}
              </button>
            </div>
          </div>
          
          <button 
            className="onboarding-skip"
            onClick={skipTour}
          >
            Skip Tour
          </button>
        </div>
        
        {/* Pointer Arrow */}
        <div className="onboarding-arrow" />
      </div>
    </>
  );
};

export default OnboardingTour;